import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconPath(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 10.412L8.8 15l-1.23-1.086 3.11-2.738H1V2h1.733v7.647h7.948L7.569 6.91 8.8 5.824z"
      />
    </Icon>
  )
}
